export const getLoaderHtml = (title, msg) => `
      <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <h1 style="font-size: 20px; font-weight: 600; text-align: center; line-height: 32px; color: black; text-transform: uppercase; padding: 0; margin: 0;">${title}</h1>
        <p style="padding: 0; margin: 0;">${msg}</p>
        <div style="display: flex; justify-content: center; align-items: center; width: 100%; border: 1px solid transparent; border-radius: 3px; padding: 10px; text-align: center;">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="158px"
            height="24px"
            viewBox="0 0 158 24"
          >
            <path
              fill="#e8e8e8"
              fill-opacity="0.11"
              d="M64 4h10v10H64V4zm20 0h10v10H84V4zm20 0h10v10h-10V4zm20 0h10v10h-10V4zm20 0h10v10h-10V4zM4 4h10v10H4V4zm20 0h10v10H24V4zm20 0h10v10H44V4z"
            />
            <path
              fill="#c4c4c4"
              fill-opacity="0.26"
              d="M144 14V4h10v10h-10zm9-9h-8v8h8V5zm-29 9V4h10v10h-10zm9-9h-8v8h8V5zm-29 9V4h10v10h-10zm9-9h-8v8h8V5zm-29 9V4h10v10H84zm9-9h-8v8h8V5zm-29 9V4h10v10H64zm9-9h-8v8h8V5zm-29 9V4h10v10H44zm9-9h-8v8h8V5zm-29 9V4h10v10H24zm9-9h-8v8h8V5zM4 14V4h10v10H4zm9-9H5v8h8V5z"
            />
            <g>
              <path
                fill="#f2f2f2"
                fill-opacity="0.15"
                d="M-58 16V2h14v14h-14zm13-13h-12v12h12V3z"
              />
              <path fill="#bababa" fill-opacity="0.39" d="M-40 0h18v18h-18z" />
              <path
                fill="#bdbdbd"
                fill-opacity="0.3"
                d="M-40 18V0h18v18h-18zm17-17h-16v16h16V1z"
              />
              <path fill="#bababa" fill-opacity="0.39" d="M-20 0h18v18h-18z" />
              <path
                fill="#999999"
                fill-opacity="0.7"
                d="M-20 18V0h18v18h-18zM-3 1h-16v16h16V1z"
              />
              <animateTransform
                attributeName="transform"
                type="translate"
                values="20 0;40 0;60 0;80 0;100 0;120 0;140 0;160 0;180 0;200 0"
                calcMode="discrete"
                dur="1800ms"
                repeatCount="indefinite"
              />
            </g>
          </svg>
        </div>
      </div>
`;
